import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

// Scroll Animation Wrapper (Consistency kosam)
const FadeInSection = ({ children, delay = 0 }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setVisible(true);
      });
    }, { threshold: 0.1 }); 
    if (domRef.current) observer.observe(domRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={domRef} className={`transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

const ComingSoon = ({ pageName }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    // Dark theme removed, premium light background added
    <main className="min-h-screen flex flex-col justify-center items-center px-6 relative bg-[#f8fafc] overflow-hidden">
      
      {/* Background Decorative Gradients */}
      <div className="absolute top-[-10%] right-[-10%] w-[400px] h-[400px] bg-[#e85d04]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-[#e85d04]/10 rounded-full blur-3xl"></div>

      <div className="z-10 text-center max-w-2xl">
        <FadeInSection>
          {/* Updated Badge Style */}
          <div className="inline-block border border-[#e85d04]/30 bg-[#e85d04]/10 rounded-full px-5 py-2 text-xs font-bold text-[#e85d04] mb-8 uppercase tracking-widest shadow-sm">
            Update in Progress
          </div>
          
          {/* Dynamic Heading with Orange Accent */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 mb-6 tracking-tight capitalize">
            {pageName} <span className="text-[#e85d04]">.</span>
          </h1>
          
          {/* Subheading */}
          <p className="text-lg md:text-xl text-slate-600 mb-12 leading-relaxed">
            We are crafting something extraordinary for this section. Our team is working hard to bring you the best experience soon!
          </p>

          {/* Action Buttons for Navigation */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/">
              <button className="bg-[#e85d04] hover:bg-[#dc2f02] text-white px-10 py-4 rounded-2xl font-bold shadow-xl shadow-orange-500/20 active:scale-95 transition-all">
                Go Back Home
              </button>
            </Link>
            <Link to="/contact">
              <button className="bg-white border border-slate-200 text-slate-700 px-10 py-4 rounded-2xl font-bold hover:bg-slate-50 transition-all shadow-sm">
                Contact Us
              </button>
            </Link>
          </div>
        </FadeInSection>
      </div>

      {/* Floating Animated Circles for Premium Feel */}
      <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-[#e85d04]/20 rounded-full animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/3 w-3 h-3 bg-[#e85d04]/40 rounded-full animate-bounce delay-700"></div>
    </main>
  );
};

export default ComingSoon;